<template>
  <div>
    <ErrorAlerts />
    <StakeholderLookupForm />
    <Register v-if="showRegisterModal" />
    <Update v-if="showUpdateModal" />
    <LanguageSelect />
  </div>
</template>

<script>
import { mapState } from "vuex";

import StakeholderLookupForm from "@/components/StakeholderLookup/StakeholderLookupForm";
import Register from "@/components/StakeholderLookup/Register.vue";
import Update from "@/components/StakeholderLookup/Update.vue";
import LanguageSelect from "@/components/Utilities/LanguageSelect";
import ErrorAlerts from "@/components/Utilities/ErrorAlerts.vue";

export default {
  components: {
    StakeholderLookupForm,
    Register,
    Update,
    LanguageSelect,
    ErrorAlerts
  },
  computed: mapState("stakeholders", [
    "showRegisterModal",
    "showUpdateModal",
    "showNetworkAlert",
    "showDuplicateAlert"
  ])
};
</script>

<style>
.v-card__text, .v-card__title {
  word-break: normal;
}
</style>